export const dynamicItemListItemDefault = {
	inject: {
		itemId: {
			default: null
		}
	},

	computed: {
		currentVariation() {
			return this.$store.getters[`${this.itemId}/currentItemVariation`];
		}
	},

	beforeMount() {
		this.initializeList();
	},

	watch: {
		currentVariation: {
			handler(_n, oldVariation) {
				if (oldVariation) {
					this.$nextTick(() => {
						this.initializeList(true);
					});
				}
			},
			deep: true
		}
	}
};
